export default __webpack_public_path__ + "static/media/bedc_logo.15dbf0f1.jpeg";